import { Dialog } from '@base-ui/react/dialog';

import { cn } from '../../../../../utils/cn';
import type { Size } from '../../types';

export interface Props extends Dialog.Popup.Props {
  size?: Size;
}

const SIZE_CLASSES = {
  sm: 'w-[var(--w-modal-small)]',
  md: 'w-[var(--w-modal-medium)]',
  lg: 'w-[var(--w-modal-large)]',
  xl: 'w-[var(--w-modal-extra-large)]',
};

export const Popup = ({ size = 'md', className, ...restProps }: Props) => {
  const popupClass = cn(
    'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
    'max-w-[calc(100%-var(--spacing-sm1)*2)]',
    'z-modal',
    'shadow-overlay',
    'box-border',
    'border border-border-subtle-inverse',
    'rounded-medium',
    'bg-background',
    SIZE_CLASSES[size],
    'py-sm4 px-sm3',
    'xs:px-sm4',
    className,
  );
  return (
    <Dialog.Popup
      aria-modal="true"
      className={popupClass}
      onClick={event => event.stopPropagation()}
      {...restProps}
    />
  );
};
